// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"g1-z"};